import { Injectable } from "@angular/core";
import { AwsImage } from "@dotcom-frontend/data";

@Injectable({
  providedIn: "root"
})
export class ImageService {
  getImageUrl(image: AwsImage | undefined, requestWidth: number) {
    if (image) {
      const imageUrl = new URL(image.url);
      let imageDomain = imageUrl.origin;
      if (imageUrl.host.startsWith("local-cms")) {
        imageDomain = "";
      }

      return `${imageDomain}/cdn-cgi/image/width=${requestWidth}${imageUrl.pathname}`;
    }
    return;
  }
}
